module.exports = __webpack_public_path__ + "img/red_075.eff2af7d.png";